// @core/api/endpoints/affiliate/activate_campaign.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ActivateCampaignRequest,
  CampaignResponse,
} from '../../../types/affiliate';

const BASE_PATH = '/affiliate';

/**
 * Activate campaign
 * Performs activate operation on campaign.
 */
export async function ActivateCampaign(
  campaign_id: string,
  data: ActivateCampaignRequest,
  options?: RequestOptions
): Promise<CampaignResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/campaigns/:campaign_id/activate`;
  requestPath = requestPath.replace(':campaign_id', encodeURIComponent(campaign_id));
  const requestOptions = options;
  return client.post<CampaignResponse>(requestPath, data, requestOptions);
}
